import React, { useContext, useEffect, useState } from 'react';
import './sidebar.scss';
import Icon from '@ant-design/icons';
import { ReactComponent as ProfileSvg } from '../../assets/icons/profile-svg.svg';
import { ReactComponent as BillingSvg } from '../../assets/icons/Property 1=Bill.svg';
import { ReactComponent as LogoutSvg } from '../../assets/icons/logout.svg';
import { modelDropdown, sidebarMenu1, sidebarMenu2, languagesDropdown, plans } from '../../constant';
import create from '../../assets/icons/jam_write-f.svg';
import { PlusOutlined, ThunderboltOutlined, SearchOutlined } from '@ant-design/icons';
import { ReactComponent as BlogIcon } from '../../assets/icons/blogcount.svg';
import { ReactComponent as twinkle_icon } from '../../assets/icons/Sprinkle.svg';
import { ReactComponent as DownArrow } from '../../assets/icons/DownArrow.svg';
import { ReactComponent as Info } from '../../assets/icons/Info.svg';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import open_sidebar from '../../assets/icons/open_sidebar.svg';
import close_sidebar from '../../assets/icons/fontisto_close.svg';
import { Avatar, Button, Collapse, message, Radio, Tooltip } from 'antd';
import axios from 'axios';
import { GlobalContext } from '../../Context';
import packageJson from '../../../package.json';

interface SidebarProps {
  mobileOpen?: boolean;
  onMobileClose?: () => void;
}

function Sidebar({ mobileOpen, onMobileClose }: SidebarProps) {
  const [visible, setVisible] = useState(false);
  const userId = localStorage.getItem('userId');
  const [email, setEmail] = useState('');
  const [remBlog, setRemBlog] = useState(0);
  const [totalBlog, setTotalBlog] = useState(0);
  const [remAudit, setRemAudit] = useState(0);
  const [totalAudit, setTotalAudit] = useState(0);
  const [remAeo, setRemAeo] = useState(0);
  const [totalAeo, setTotalAeo] = useState(0);
  const [planDetails, setPlanDetails] = useState<any>([]);
  const [plan, setPlans] = useState([]);
  const [isLoadingPlan, setIsLoadingPlan] = useState(true);
  const [collapsed, setCollapsed] = useState(false);
  const [imageDataUrl, setImageDataUrl] = useState<any>();
  const {
    setStep4Data,
    setStep2Data,
    setStep1Data,
    setParsona,
    setBrandVoice,
    setStep3Data,
    setDraftId,
    setRegenerate,
    setCurrentScreen,
    step3Data,
    setVisited,
    userLanguage,
    userModel,
    setSelectedModel,
    setSelectedLanguage,
    setDraftData, // Added to reset draft data
    stepLoader
  }: any = useContext(GlobalContext);

  const handleButtonClick = () => {
    setVisible(!visible); // Toggle visibility on click
  };
  const { setUserLanguage, setUserModel, userName }: any = useContext(GlobalContext);

  const navigate = useNavigate();
  const toggleCollapsed = () => {
    setCollapsed((prev) => !prev);
  };

  const { pathname } = useLocation();
  const [selectedModelValue, setSelectedModelValue] = useState('Gemini-3.5 Flash');
  const [selectedLanguage, setSelectedLanguageValue] = useState('English');
  const handleRadioChange = (item: any) => {
    setSelectedModelValue(item.value);
    setUserModel(item.id);
    let value = {
      model: item.id
    };
    axios
      .post(`${process.env.REACT_APP_SERVER_URL}/change-model?userId=${userId}`, value, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`
        }
      })
      .then((res) => {
        message.success({
          content: res.data.message,
          key: 'change-model'
        });
      })
      .catch((err) => {
        console.log(err);
        message.error('Unable to change Model. Please, try again later.');
      });
  };

  //for language
  const handleLanguageRadioChange = (item: any) => {
    setSelectedLanguageValue(item.value);
    setUserLanguage(item.value);
    let value = {
      language: item.id
    };
    axios
      .post(`${process.env.REACT_APP_SERVER_URL}/change-language?userId=${userId}`, value, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`
        }
      })
      .then((res) => {
        message.success({
          content: res.data.message,
          key: 'change-language'
        });
      })
      .catch((err) => {
        console.log(err);
        message.error('Unable to change language. Please, try again later.');
      });
  };
  useEffect(() => {
    const token = localStorage.getItem('accessToken');
    if (!token || token === 'null' || token === 'undefined' || !userId || userId === 'null') {
      console.log('Sidebar: Skipping authenticated calls for guest');
      return;
    }
    axios
      .get(`${process.env.REACT_APP_SERVER_URL}/plan-details?userId=${userId}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      .then((res) => {
        setPlanDetails(res.data);
      })
      .catch((err) => {
        console.log(err);
        message.error('Unable to fetch plan details. Please, try again later.');
      })
      .finally(() => {
        setIsLoadingPlan(false);
      });

    axios
      .get(`${process.env.REACT_APP_SERVER_URL}/plans`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      .then((res) => {
        setPlans(res.data);
      })
      .catch((err) => {
        console.log(err);
        message.error('Unable to fetch plan details. Please, try again later.');
      });
  }, [userId]);

  const dropdownContent = (
    <div className='radio-buttons-parent-sidebar llm-model'>
      <Radio.Group value={selectedModelValue}>
        {modelDropdown.map((item, key) => {
          return (
            <Radio
              name={item.id}
              key={item.id}
              value={item.value}
              className={`${item?.value === selectedModelValue ? 'sidebar-radio-content' : ''}    `}
              onChange={(e) => handleRadioChange(item)}
              disabled={stepLoader || !planDetails || !plans[planDetails.name]?.includes(item.type)}
            >
              {item.value}
              {!planDetails ||
                (!plans[planDetails.name]?.includes(item.type) && (
                  <span className='info-radio-dropdown'>
                    <Tooltip title={`To access ${item?.value}, you need to upgrade your plan.`}>
                      <Icon component={Info} />
                    </Tooltip>
                  </span>
                ))}
              <span className={`${item?.type ? 'free-container' : ''}`}>{item?.type ? item?.type : ''}</span>
            </Radio>
          );
        })}
      </Radio.Group>
    </div>
  );

  //language
  const dropdownLanguageContent = (
    <div className='radio-buttons-parent-sidebar language-selection'>
      <Radio.Group value={selectedLanguage}>
        {languagesDropdown.map((item: any) => {
          return (
            <Radio
              key={item.id}
              value={item.value}
              className={`${item?.value === selectedLanguage ? 'sidebar-radio-content' : ''}    `}
              onChange={(e) => handleLanguageRadioChange(item)}
              disabled={stepLoader || !planDetails || !plans[planDetails.name]?.includes(item.type)}
            >
              {item.value}

              {/* <span className={`${item?.type ? 'free-container' : ''}`}>{item?.type ? item?.type : ''}</span> */}
            </Radio>
          );
        })}
      </Radio.Group>
    </div>
  );
  //collapse  items
  const items: any = [
    {
      key: '1',
      label: <>LLM Model</>,
      children: dropdownContent
    },
    {
      key: '2',
      label: (
        <>
          Languages{' '}
          <span>
            {(planDetails.name === 'Free' || planDetails.name === 'Basic') && (
              <Tooltip title='Upgrade to Pro OR Agency plan to generate Blogs in different languages'>
                <Icon component={Info} />
              </Tooltip>
            )}
          </span>
        </>
      ),
      children: dropdownLanguageContent
    }
  ];
  //onChange for for collapse
  const onChange = (key: string | string[]) => {};

  const createInitialsImage = (name: any, size = 100, bgColor = '#ff7c02', textColor = '#ffffff') => {
    // Extract initials
    const getInitials = (name: string) => {
      if (!name) return '';
      const nameParts = name.split(' ');
      return nameParts
        .map((part) => part.charAt(0).toUpperCase())
        .slice(0, 2)
        .join('');
    };

    const initials = getInitials(name);

    // Create a canvas element
    const canvas = document.createElement('canvas');
    canvas.width = size;
    canvas.height = size;

    const ctx = canvas.getContext('2d');
    if (!ctx) return null;

    // Draw background
    ctx.fillStyle = bgColor;
    ctx.fillRect(0, 0, size, size);

    // Draw initials
    ctx.fillStyle = textColor;
    ctx.font = `${size / 2}px Arial`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(initials, size / 2, size / 2);

    // setImageDataUrl(canvas.toDataURL('image/png')); // No longer needed here
  };
  const getUsage = async () => {
    const usage = await axios.get(`${process.env.REACT_APP_SERVER_URL}/usage?userId=${userId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`
      }
    });
    setTotalBlog(usage?.data?.blogLimit || 0);
    setRemBlog(usage?.data?.blogLimit - usage?.data?.blogCreated);
    const auditTotal = usage?.data?.blogAuditLimit || 0;
    const auditUsed = usage?.data?.blogAuditUsed || 0;
    setTotalAudit(auditTotal);
    setRemAudit(Math.max(auditTotal - auditUsed, 0));
    const aeoTotal = usage?.data?.aeoScanLimit || 0;
    const aeoUsed = usage?.data?.aeoScanUsed || 0;
    setTotalAeo(aeoTotal);
    setRemAeo(Math.max(aeoTotal - aeoUsed, 0));
  };

  useEffect(() => {
    const token = localStorage.getItem('accessToken');
    const isGuest = !token || token === 'null' || token === 'undefined' || !userId || userId === 'null';
    
    setSelectedModelValue(modelDropdown.find((item) => item.id === userModel)?.value || '');
    setSelectedLanguageValue(languagesDropdown.find((item) => item.value === userLanguage)?.value || '');
    
    if (!isGuest) {
        getUsage();
    }
    
    createInitialsImage(userName);
    if (pathname.includes('/createblog')) {
      setCollapsed(true);
    } else {
      setCollapsed(false);
    }
  }, [pathname, userName, userLanguage, userModel, userId]);



  const handleWidth = () => {
    if (window.innerWidth <= 768) {
      return 270;
    }
    if (collapsed) {
      return 0;
    } else if (window.innerWidth < 1441 && window.innerWidth > 1201) {
      return 270;
    } else if (window.innerWidth < 1200) {
      return 275;
    } else {
      return 270;
    }
  };

  return (
    <div className={`sidebar-content ${pathname.includes('/createblog') ? 'close-sidebar' : ''} ${mobileOpen ? 'mobile-open' : ''}`}>
      <div
        className={`sidebar-wrapper ${collapsed && !mobileOpen ? 'collapsed' : ''}`}
        style={{
          // width: collapsed ? 0 : 270,
          width: handleWidth()
        }}
      >
        <div className='create-btn-div'>
          <Button
            disabled={remBlog == 0 || stepLoader ? true : false}
            className='create-btn'
            onClick={() => {
            localStorage.setItem('blog-mode','create')
            // Reset all draft data for new blog
            setDraftData({
              id: '',
              userId: userId,
              topic: '',
              title: '',
              primaryKeyword: '',
              location: null,
              secondaryKeywords: [],
              brandVoice: null,
              aiPersona: null,
              internalLinks: [],
              referencedata: [],
              outline: '',
              visitedstep: 0,
              outlineRegeneratedCount: 0 // KEY: Initialize to 0 for new blogs
            });
              setStep1Data({
                topic: '',
                selectedLocation: null,
                primaryKeyword: '',
                title: ''
              });

              setStep2Data({
                scrappedUrl: [],
                files: []
              });

              setStep3Data({
                secondaryKeywords: [],
                temp: [],
                removedRows: [],
                hasGeneratedSecondaryKeywords: false
              });

              setStep4Data({
                links: []
              });
              setRegenerate(false);
              setBrandVoice([]);
              setParsona([]);
              setDraftId('');
              setCurrentScreen(1);
              setVisited(0);
              setSelectedLanguage(userLanguage);
              setSelectedModel(userModel);
              navigate('/createblog');
            }}
          >
            <img src={create} alt='create' />
            <span>Create</span>
          </Button>
        </div>

        <div className='submenu-items'>
          <div className='submenu1'>
            <ul>
              {sidebarMenu1.map((item: any) => {
                return (
                  <li
                    key={item.key}
                    className={`${pathname.startsWith('/' + item?.url) ? 'active' : ''} ${item?.url} ${stepLoader ? 'disabled-sidebar-item' : ''}`}
                    style={stepLoader ? { pointerEvents: 'none', opacity: 0.6 } : {}}
                  >
                    {' '}
                    <Tooltip placement='left' title={item.tooltip}>
                      <Link to={stepLoader ? '#' : `/${item?.url}`} onClick={(e) => { if (stepLoader) e.preventDefault(); else onMobileClose?.(); }}>
                        <Icon component={item?.icon} /> {item.label}
                      </Link>
                    </Tooltip>
                  </li>
                );
              })}
              <li className='mobile-only-nav-item separator'><Link to='/profile' onClick={() => onMobileClose?.()}><Icon component={ProfileSvg} /> Profile</Link></li>
              <li className='mobile-only-nav-item'><Link to='/account' onClick={() => onMobileClose?.()}><Icon component={BillingSvg} /> Account</Link></li>
              <li className='mobile-only-nav-item'><Link to='/support-tickets' onClick={() => onMobileClose?.()}><span className='sidebar-support-badge'><img src={`${process.env.PUBLIC_URL}/Frame.png`} alt='support' className='support-frame-icon' /></span> Support</Link></li>
              <li className='mobile-only-nav-item logout-item'><Link to='#' onClick={(e) => { e.preventDefault(); localStorage.clear(); navigate('/login'); }}><Icon component={LogoutSvg} /> Logout</Link></li>
            </ul>
            <hr className='horizontal-rule-sidebar' />
            <div className='sidebar-collapse-parent-container'>
              <Collapse
                collapsible={stepLoader ? 'disabled' : undefined}
                expandIcon={() => <Icon component={DownArrow} />}
                items={items}
                defaultActiveKey={['1', '2']}
                onChange={onChange}
              />
            </div>
          </div>

          <div className='submenu2'>
            <div className='workspace-credits-sidebar'>
              <div className='workspace-credits-top'>
                <span className='workspace-credits-label'>Workspace Credits</span>
                <Tooltip title="Buy more credits">
                  <div
                    className='add-addon-btn-compact'
                    onClick={() => !stepLoader && navigate('/account?tab=1')}
                    style={stepLoader ? { cursor: 'not-allowed', opacity: 0.6 } : {}}
                  >
                    <PlusOutlined />
                  </div>
                </Tooltip>
              </div>

              <div className='credit-items-list'>
                <Tooltip title={`${remBlog} of ${totalBlog} blog generations remaining`} placement="right">
                  <div className='credit-item'>
                    <div className='credit-item-header'>
                      <div className='credit-item-title'>
                        <span className='credit-icon-wrap'><Icon component={BlogIcon} /></span> Blog
                      </div>
                      <div className='credit-item-count'>
                        {remBlog} <span className='credit-item-total'>/ {totalBlog}</span>
                      </div>
                    </div>
                    <div className='credit-bar'>
                      <div className='credit-fill' style={{ width: `${totalBlog > 0 ? Math.min(((totalBlog - remBlog) / totalBlog) * 100, 100) : 0}%` }} />
                    </div>
                  </div>
                </Tooltip>

                <Tooltip title={`${remAudit} of ${totalAudit} blog audit credits remaining`} placement="right">
                  <div className='credit-item'>
                    <div className='credit-item-header'>
                      <div className='credit-item-title'>
                        <span className='credit-icon-wrap'><ThunderboltOutlined /></span> Audit
                      </div>
                      <div className='credit-item-count'>
                        {remAudit} <span className='credit-item-total'>/ {totalAudit}</span>
                      </div>
                    </div>
                    <div className='credit-bar'>
                      <div className='credit-fill' style={{ width: `${totalAudit > 0 ? Math.min(((totalAudit - remAudit) / totalAudit) * 100, 100) : 0}%` }} />
                    </div>
                  </div>
                </Tooltip>

                <Tooltip title={`${remAeo} of ${totalAeo} AEO scan credits remaining`} placement="right">
                  <div className='credit-item'>
                    <div className='credit-item-header'>
                      <div className='credit-item-title'>
                        <span className='credit-icon-wrap'><SearchOutlined /></span> AEO
                      </div>
                      <div className='credit-item-count'>
                        {remAeo} <span className='credit-item-total'>/ {totalAeo}</span>
                      </div>
                    </div>
                    <div className='credit-bar'>
                      <div className='credit-fill' style={{ width: `${totalAeo > 0 ? Math.min(((totalAeo - remAeo) / totalAeo) * 100, 100) : 0}%` }} />
                    </div>
                  </div>
                </Tooltip>
              </div>
            </div>
          </div>
          <span style={{ fontSize: '12px', color: 'gray' }}>Version: {packageJson?.version}</span>
        </div>
      </div>

      {pathname.includes('/createblog') && (
        <button className='collapse-btn' onClick={toggleCollapsed} style={{ marginBottom: 16 }}>
          {collapsed ? <img src={open_sidebar} alt='' /> : <img src={close_sidebar} alt='' />}
        </button>
      )}
    </div>
  );
}

export default Sidebar;
